import { BcIntegrationsManager, BcPlayer } from "types/brightcove";

export type BrightcoveWebSdk = { IntegrationsManager: BcIntegrationsManager; Player: BcPlayer, SsaiIntegrationFactory: any };

export const loadBrightcoveSdkScript = (): Promise<BrightcoveWebSdk> => {

  const webSdkPromise = new Promise<BrightcoveWebSdk>((resolve) => {
    const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://players.brightcove.net/sdk/v1.0.3/web-sdk/ui/index.iife.min.js';
      script.onload = (...args: any) => {
        resolve((window as any).BrightcoveWebSdkPlayback);
      };
      document.head.appendChild(script);
  });

  const ssaiIntegration = new Promise<BrightcoveWebSdk>((resolve) => {
    const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://players.brightcove.net/sdk/v1.0.3/web-sdk/integrations/ssai/index.iife.min.js';
      script.onload = (...args: any) => {
        resolve((window as any).BrightcoveWebSdkUi);
      };
      document.head.appendChild(script);
  });

  return Promise.all([webSdkPromise, ssaiIntegration]).then(() => {
    return {...(window as any).BrightcoveWebSdkUi, ...(window as any).BrightcoveWebSdkSsaiIntegration};
  })
}